import classNames from "classnames";
import * as React from "react";
import ReactTooltip from "react-tooltip";
import { Or } from "source/app/domain/Or";
import { GetChevronPanelStyle } from "source/app/presentation/Shared/ChevronPanel/Helpers/GetChevronPanelStyle";
import { Style } from "source/app/presentation/Shared/Styles/CSS";
import { Sounds } from "../../../services/Sound/Sounds";
import Chevron from "../../MainPanel/Dreams/DreamsPanelTitle/Chevron/Chevron";
import Hyperlink from "../Link/Hyperlink";
import RPGIcon from "../RPGIcon/RPGIcon";
import Render from "../Render";
import * as styles from "./ChevronPanel.css";
import { IChevronPanelProps } from "./IChevronPanelProps";
import { ShareStateMultiple } from "source/app/services/UI/State/ShareState";
import { ESharedFunctionMultiple } from "motw_core/Enums/ESharedFunction";

const ChevronPanel: React.FC<IChevronPanelProps> = (props) => {
    const [isOpen, setIsOpen] = React.useState(
        props.shouldOpenByDefault === true
    );

    const Toggle = () => {
        const sound = isOpen ? Sounds.wooden_thump : Sounds.wooden_creak;
        sound.Play();

        if (props.whenClicked) {
            props.whenClicked();
        }

        setIsOpen(!isOpen);
    };

    React.useEffect(() => {
        ReactTooltip.rebuild();
    }, [isOpen]);

    React.useEffect(() => {
        if (props.shouldOpenByDefault) {
            setIsOpen(true);
        }
    }, [props.shouldOpenByDefault]);

    const panelStyle = GetChevronPanelStyle({
        isOpen,
        style: props.style,
        dynamicOpacity: props.dynamicOpacity,
        state: { isOpen },
    });

    const chevronPanelId = `ChevronPanel_${props.id}`;

    ShareStateMultiple(
        ESharedFunctionMultiple.ChevronPanel_isOpen,
        chevronPanelId,
        isOpen,
        setIsOpen
    );

    return (
        <div
            id={chevronPanelId}
            data-tip={Or(props.tooltip, "")}
            className={classNames(styles.panel, props.withClasses, {
                [styles.panel_opened]: isOpen,
            })}
            {...Style(
                `chevronPanelStyle_${isOpen}_${props.style}_${props.dynamicOpacity}`,
                panelStyle
            )}
        >
            <Hyperlink whenClicked={() => Toggle()}>
                <Render id="icon" when={props.icon} withClasses={styles.icon}>
                    {props.icon ? <RPGIcon icon={props.icon} /> : null}
                </Render>
                <Render
                    id="label"
                    when={props.label}
                    withClasses={styles.label}
                >
                    {props.label}
                </Render>
                <Chevron
                    isUp={isOpen}
                    reduceOpacity={props.reduceChevronOpacity}
                />
            </Hyperlink>
            <Render id="chevronPanelChildren" when={isOpen}>
                {props.children}
            </Render>
        </div>
    );
};

export default ChevronPanel;
